import React, { useState } from "react";

import PageHeading from "../../../components/common/PageHeading";
import RightBar from "../../../components/common/RightBar";

import { Card, Checkbox, Col, Form, Row, Input, Select, Radio } from "antd";
import { MdEmail, MdAddCircle } from "react-icons/md";
import { RiCloseCircleLine } from "react-icons/ri";
import FormAction from "../../../components/common/FormAction";
import Footer from "../../../components/common/Footer";

import "./RentalApplicationCustomization.css";
import RightBarMethod from "../../../components/common/RightBar/RightBarMethod";
import ConfirmationBox from "../../../components/common/ConfirmationBox";

const { TextArea } = Input;
const RentalApplicationCustomizationRightBar = [
  RightBarMethod("Tasks", "t1", <i className="fa-solid fa-star"></i>, [
    RightBarMethod("Preview Application", "1", "", "", ""),
    RightBarMethod("Preview Co-Signer Application", "2", "", "", ""),
    RightBarMethod("Rental Application Fees", "3", "", "", "/generalsettings/rental-application-fees"),
    RightBarMethod("Bulk Update Application Fees", "4", "", "", "/leasing/rental-applications/bulk-update-application-fees"),
  ]),
];

const applicantInstructions = `To complete your application later just click on the save button at the bottom to return and finish at a later time.

For updates on your application status please text us at 251-577-4036

Your application will not be processed until completed.

Minimum Requirements for Approval:

· Each adult that will be living in the home must be fill out an application;
· The total household monthly net income must be over 3 times the rent;
· All adults must have no evictions in the last 5 years, pass a background check, and have a good rental history if they are currently renting;
· Have a minimum credit score of 600.
-we must have recent check stubs within the last 60 days
-Your employer should be local or a job that allows remote work.  If your job is out of town we would need proof of local employment to be approved
-cosigners must have a credit score of over 700
-cosigners must have income outside of social security or other government benefits
-cosigners income must be 3 times the rent after subtracting their personal expense and debts.

Please be prepared to pay the application fee as outlined in the property listing. In addition to this rental application, you will also be required to provide a copy of a valid form of identification and proof of income.

To complete this rental application, you must be prepared to provide 3 years of residential history as well as contact information for your rental references. You will also be asked to provide information on your monthly income, and please note that most properties require that applicant combined NET income is at least three (3) times the monthly rent amount.

Each resident over the age of 18 must fill out an application.

PET/ANIMAL SCREENING IS A REQUIRED PART OF THE APPLICATION PROCESS FOR ALL APPLICANTS: There is no cost for households with no pets or with service animals.

A welcoming environment is paramount to all of our residents. To help ensure ALL of our residents understand our pet and animal-related policies, we use a third-party screening service and require EVERYONE to complete a profile (No Pet/Pet/Animal). This process ensures we have formalized pet and animal-related policy acknowledgments and more accurate records to create greater mutual accountability. If you need accommodation in another way, please contact your housing provider. We are not able to accept pit bulls and similar dog breeds. We have a 2 pet/animal maximum at each property. There is a $25/month pet fee for approved pets, with no additional deposit. Each property listing indicates if pets are accepted or not accepted the property.

The Non-Refundable application fee is $45 per adult and must be paid when submitting this application.
When your application is approved there will be a $75 Lease Prep fee due at the signing of the lease.

As a company we obey the Fair Housing Act. We do not discriminate against any person because of Race, Color, Religion, Sex, Handicap, Familial Status, or National Origin.

All tenants are required to sign up for the Resident Benefit Package at a cost of $13 per month and provide proof of their own renters insurance and name Integrity Oklahoma as Additionally Insured. The insurance fee will be separate from the $13 benefit fee.  If the tenant does not provide proof of insurance they will be enrolled in our renters insurance policy for a fee of approx. $12 per month as outlined in the lease.

Some properties qualify for the $0 Security Deposit program.  With this program you would pay an Admin fee of $50 at move in and sign up for a plan with SayRhino.com.  They would then bill you a small monthly fee based on your credit score.  Fees can be as low as $15 per month.  This can be much cheaper than paying a full deposit at move in!

HOW TO GET APPROVED FASTER!

1. make sure all adults in your household have applied

2. make sure and view the home in person

3. make sure and turn in proof of income or tax returns (this must be an official document)

4. make sure and provide a phone number and email address for all landlords

Application fee: $45.00 per adult`;

const historyInstructions = `Please provide 3 years of residential history`;

const attachmentsInstructions = `Please upload all required documentation including:

- Photo ID
- Proof of income (e.g. recent pay stubs, or tax returns)- THIS MUST BE RECENT PROOF WITHIN THE LAST 60 DAYS
- Photos of pets (if any). Please note - we are not able to accept pit bulls and similar breeds.
- Proof of assistance if on section 8 or other subsidized housing program
-all applicants must fill out the pet screening application as well at https://integrityokc.petscreening.com`;

const termsofAgreements = `The following Application Agreement will be signed by all applicants prior to signing a lease contract. While some of the information below may not yet be applicable to your situation, there are some provisions that may become applicable prior to signing a lease contract. In order to continue with this online application, you'll need to review the Application Agreement carefully and acknowledge that you accept its terms.

1.	I understand that this is a routine application to establish background, credit, character, employment, and rental history. I also understand that this is NOT an agreement to rent and that all applications must be approved. I authorize a credit and background check to be done on my behalf and verification of references to be given. I declare that the statements above are true and correct, and I agree that the landlord may terminate my agreement entered into in reliance on any misstatement made above.

2.	Application Fee (nonrefundable). You have delivered to our representative an application fee in the amount indicated below, and this payment partially defrays the cost of administrative paperwork. It's nonrefundable.

3.	If You Fail to Sign Lease Contract After Approval. Unless we authorize otherwise in writing, you and all co-applicants must sign the Lease Contract within 1 days after we give you our approval in person, by telephone, text or by email.  If you or any co-applicant fails to sign as required, we may offer the property to another applicant.

4.	Completed Application. An Application will not be considered "completed" until all of the following have been provided to us: a separate Application has been fully filled out and signed by you and each co-applicant; an application fee has been paid to us. Photo ID and proof of income must be submitted, all are necessary for the Application to be considered completed.

5.	Non-approval. We will notify you whether you've been approved within 10 days after the date we receive a completed Application. Your Application will be considered "disapproved" if we fail to notify you of your approval within 10 days after we have received a completed Application. Notification may be in person or by mail or telephone unless you have requested that notification be by mail. You must not assume approval until you receive actual notice of approval. The 10-day time period may be changed only by separate written agreement.

6.	Extension of Deadlines. If the deadline for signing, approving, falls on a Saturday, Sunday, or a state or federal holiday, the deadline will be extended to the end of the next day.

7.	Notice to or from Co-applicants. Any notice we give you or your co-applicant is considered notice to all co-applicants; and any notice from you or your co-applicant is considered notice from all co-applicants.

8.	Keys or Access Devices. We'll furnish keys and/or access devices only after: (1) all parties have signed the contemplated Lease Contract and other rental documents referred to in the Lease Contract; and (2) all applicable rents and security deposits have been paid in full.

9.	Signature. Our reception of this application is consent only to this Application Agreement. It does not bind us to accept applicant or to sign the proposed Lease Contract.

10.  All tenants are required to sign up for the Resident Benefit Package at a cost of $13 per month or provide proof of their own renters insurance that meets the same minimum coverage requirements as the Tenant Benefit Package and name Integrity Oklahoma as Additionally Insured or the tenant will be enrolled in the Group renters Insurance program for an additional cost of $12.00 per month.

11.THIS IS A REQUIRED PART OF THE APPLICATION PROCESS FOR ALL APPLICANTS
To help ensure ALL of our residents understand our pet and animal-related policies, we use a third-party screening service and require EVERYONE to complete a profile (No Pet/Pet/Animal). This process ensures we have formalized pet and animal-related policy acknowledgments and more accurate records to create greater mutual accountability.

Please get started by selecting a profile category on our landing page. Copy and paste the following link in another tab: https://integrityokc.petscreening.com/
`;

const inputArr = [
  {
    type: "text",
    id: 1,
    value: "",
  },
];

const inputFieldsArray = [
  {
    id: 1,
    input: {
      type: "text",
      id: 1,
      value: "",
    },
    select: {
      type: "text",
      id: 2,
      value: "",
    },
    select2: {
      type: "text",
      id: 3,
      value: "",
    },
    select3: {
      type: "text",
      id: 4,
      value: "",
    },
  },
];

const days = [];

for (let i = 0; i <= 30; i++) {
  days.push({ value: `${i} Days` });
}

function RentalApplicationCustomization() {
  const [arr, setArr] = useState(inputArr);
  const [inputFields, setInputfields] = useState(inputFieldsArray);
  const [isConfirmationBoxOpen, setIsConfirmationBoxOpen] = useState(false);
  const [value, setValue] = useState(1);
  const [idNumber, setIdNumber] = useState(2);
  const [count, setCount] = useState(2);
  

  const onChange = (e) => {
    console.log('radio checked', e.target.value);
    setValue(e.target.value);
  };

  const addInputFields = () => {
    if(inputFields.length === 0){
        setIdNumber(1);
    }
    else{
        setIdNumber(idNumber + 1);
       
    }

    setInputfields((item) => {
        return [
          ...item,
          { 
              id: idNumber,
            input: { type: "text", value: "" },
            select: {
              type: "text",
              value: "",
            },
            select2: {
              type: "text",
              value: "",
            },
            select3: {
              type: "text",
              value: "",
            },
            
          },
        ];
      });
    
   
  };

  const addInput = () => {
    if(arr.length === 0){
        setCount(1);
    }
    else{
        setCount(count + 1);
       
    }
    setArr((s) => {
      return [
        ...s,
        {
          type: "text",
          value: "",
          id: count
        },
      ];
    });
  };

  const deleteField = (id) => {
    const newArr = arr.filter((item)=>{
        return item.id !== id;
    });

    setArr(newArr);
  };

  const deleteFields = (id) => {
    const newArr = inputFields.filter((item)=>{
        return item.id !== id;
    });

    setInputfields(newArr);
  };


  return (
    <>
      <div className="page-container">
        <div className="rental-application-customization main-container">
          <div className="parent">
            <PageHeading heading="Rental Application Customization" />
            <button className="icon-btn child" onClick={()=> setIsConfirmationBoxOpen(true)}>
              <MdEmail size={16} /> <span>Feed Back</span>{" "}
            </button>
          </div>
          <Form layout="vertical">
            <Row gutter={[0, 24]}>
              <Col span={24}>
                <Card title="Questions to Exclude">
                  <Form.Item>
                    <Checkbox>
                      Don't ask if applicant is co-signer/guarantor
                    </Checkbox>
                  </Form.Item>
                  <Form.Item>
                    <Checkbox>Don't ask about dependents under 18</Checkbox>
                  </Form.Item>
                </Card>
              </Col>
              <Col span={24}>
                <Card title="Applicant Facing Terminology">
                  <Form.Item>
                    <Checkbox>
                      Use the term "animals" instead of "pets"
                    </Checkbox>
                  </Form.Item>
                </Card>
              </Col>
              <Col span={24}>
                <Card title="Co-Signer/Guarantor Application">
                  <p>
                    For co-signer/guarantor the application will exclude
                    questions about:
                  </p>
                  <ul className="list-style">
                    <li>Residential history</li>
                    <li>Other housemates</li>
                    <li>Vehicles</li>
                    <li>Emergency contact</li>
                    <li>Additional questions</li>
                  </ul>
                </Card>
              </Col>
              <Col span={24}>
                <Card title="Submission Requirements">
                  <Form.Item>
                    <p>
                      Requiring payments to be made online increases chances of
                      applicants completing the process, and saves time
                      collecting fees. Any unit with a $0 fee will allow
                      applicants to skip the payment section.
                    </p>
                  </Form.Item>
                  <Form.Item>
                    <Checkbox>Require applicants to pay fees online</Checkbox>
                  </Form.Item>
                  <Form.Item>
                    <Checkbox>
                      Require applicants to provide date of birth for other
                      occupants
                    </Checkbox>
                  </Form.Item>
                  <Form.Item>
                    <Checkbox>Require residential history details</Checkbox>
                    <ul className="list-style">
                      <li>Residential history</li>
                      <li>Monthly Rent</li>
                      <li>Landlord Name</li>
                      <li>Landlord Phone Number</li>
                      <li>Landlord Email Address</li>
                      <li>Reason for Leaving</li>
                    </ul>
                  </Form.Item>
                  <Form.Item>
                    <Checkbox>Require Employment Details</Checkbox>
                    <ul className="list-style">
                      <li>Employer Name</li>
                      <li>Employer Address</li>
                      <li>Employer Phone Number</li>
                      <li>Monthly Salary</li>
                      <li>Position Held</li>
                      <li>Years Worked</li>
                      <li>Supervisor Name</li>
                      <li>Supervisor Email Address</li>
                    </ul>
                  </Form.Item>
                  <Form.Item>
                    <Checkbox>Require Photo ID</Checkbox>
                  </Form.Item>
                  <Form.Item>
                    <Checkbox>Require Proof of Income</Checkbox>
                  </Form.Item>
                </Card>
              </Col>
              <Col span={24}>
                <Card title="Applicant Instructions">
                  <Form.Item label="Please enter what you would like applicants to see at the top of the first page of the application">
                    <TextArea
                      rows={8}
                      defaultValue={applicantInstructions}
                    ></TextArea>
                  </Form.Item>
                </Card>
              </Col>
              <Col span={24}>
                <Card title="Residential History Instructions">
                  <Form.Item
                    label="Please enter what you would like applicants to see at the top of the Where You've Lived page"
                    required
                  >
                    <TextArea
                      rows={8}
                      defaultValue={historyInstructions}
                    ></TextArea>
                  </Form.Item>
                </Card>
              </Col>
              <Col span={24}>
                <Card title="Attachments Instructions">
                  <Form.Item
                    label="Please enter what you would like applicants to see at the top of the Attach Document page"
                    required
                  >
                    <TextArea
                      rows={8}
                      defaultValue={attachmentsInstructions}
                    ></TextArea>
                  </Form.Item>
                </Card>
              </Col>
              <Col span={24}>
                <Card title="Application Questions">
                  <Row gutter={[0, 12]}>
                    <Col span={24}>
                      <p>
                        Your applicants will be required to answer these
                        questions when submitting their application. Make sure
                        your questions can be answered with a "Yes" or "No".
                      </p>
                    </Col>
                    <Col span={24}>
                      {arr.map((item, index) => {
                        return (
                          <Row gutter={[12, 0]} align="middle" key={index} id={item.id}>
                            <Col span={23}>
                              <Form.Item className="input-field-container">
                                <TextArea
                                  rows={2}
                                  value={item.value}
                                  type={item.type}
                                  defaultValue="Have you ever been convicted of a crime?"
                                />
                              </Form.Item>
                            </Col>
                            <Col span={1}>
                              <RiCloseCircleLine
                                size={24}
                                className="delete-circle-icon"
                                onClick={()=> deleteField(item.id)}
                              />
                            </Col>
                          </Row>
                        );
                      })}
                    </Col>
                    <Col span={24}>
                      <button onClick={() => addInput()} className="add-btn">
                        <MdAddCircle size={20} />
                        <span>Add another question</span>
                      </button>
                    </Col>
                  </Row>
                </Card>
              </Col>
              <Col span={24}>
                <Card title="Default Application Activities">
                  <Row gutter={[0,12]}>
                    <Col span={24}>
                      <p>
                        These activities will show on all new rental
                        applications underneath the "Upcoming Activities"
                        section and can be used as a checklist. They will not be
                        shared with the Applicant.
                      </p>
                    </Col>
                    <Col span={24}>
                      <Row gutter={[1, 0]} >
                        <Col span={6} className="header" >
                          <span className="header-col">Activity Description</span>
                        </Col>
                        <Col span={6} className="header">
                          <span className="header-col">Label</span>
                        </Col>
                        <Col span={6} className="header">
                          <span className="header-col">Assign To</span>
                        </Col>
                        <Col span={5} className="header">
                          <span className="header-col">Due After</span>
                        </Col>
                      </Row>
                    </Col>
                    <Col span={24}>
                      {inputFields.map((item, index) => {
                        return (
                          <Row gutter={[12, 0]} key={index} align="middle" id={item.id}>
                            <Col span={6}>
                              <Form.Item>
                                <Input defaultValue="Open this link - https://app.process.st/pages/Application-p" />
                              </Form.Item>
                            </Col>
                            <Col span={6}>
                              <Form.Item>
                                <Select
                                  placeholder="Start typing to search"
                                  showSearch
                                  allowClear
                                  options={[
                                    { value: "section 8" },
                                    { value: "Workflow" },
                                  ]}
                                />
                              </Form.Item>
                            </Col>
                            <Col span={6}>
                              <Form.Item>
                                <Select
                                  placeholder="Start typing to search"
                                  showSearch
                                  allowClear
                                  options={[
                                    { value: "Seerat" },
                                    { value: "Kainat" },
                                    { value: "Akash" },
                                  ]}
                                />
                              </Form.Item>
                            </Col>
                            <Col span={5}>
                              <Form.Item>
                                <Select
                                  placeholder="Start typing to search"
                                  showSearch
                                  allowClear
                                  options={days}
                                />
                              </Form.Item>
                            </Col>
                            <Col span={1}>
                              <RiCloseCircleLine
                                size={24}
                                className="delete-circle-icon"
                                onClick={()=>deleteFields(item.id)}
                              />
                            </Col>
                          </Row>
                        );
                      })}
                    </Col>
                    <Col span={24}>
                      <button
                        onClick={() => addInputFields()}
                        className="add-btn add"
                      >
                        <MdAddCircle size={20} />{" "}
                        <span>Add another default activity</span>
                      </button>
                    </Col>
                  </Row>
                </Card>
              </Col>
              <Col span={24}>
                <Card title="Your Terms of Agreement">
                  <Form.Item label="Please enter what you would like applicants to see at the top of the Attach Document page">
                    <TextArea
                      rows={8}
                      defaultValue={termsofAgreements}
                    ></TextArea>
                  </Form.Item>
                </Card>
              </Col>
              <Col span={24}>
                <FormAction />
              </Col>
            </Row>
          </Form>
          <Footer />
        </div>
      </div>
      <div className="RightSidebar">
        <RightBar RightBarData={RentalApplicationCustomizationRightBar} />
      </div>
      {
        isConfirmationBoxOpen ? <ConfirmationBox setIsConfirmationBoxOpen={setIsConfirmationBoxOpen}>
               <h2>Rental Application Customization</h2>
        <p className='message'>How satisfied are you with your ability to customize rental applications? </p>
        <div className="feedback-number-container">
        <Form layout="vertical">
            <div className="feedback-criteria">
                <span>Not at all satisfied</span>
                <span>Very satisfied</span>
            </div>
                        <Radio.Group className="feedback-field" onChange={onChange} value={value}>
                          
                                <Radio className="number-container" value={1}><span className="number">1</span></Radio>
                                <Radio className="number-container" value={2}><span className="number">2</span></Radio>
                                <Radio className="number-container" value={3}><span className="number">3</span></Radio>
                                <Radio className="number-container" value={4}><span className="number">4</span></Radio>
                                <Radio className="number-container" value={5}><span className="number">5</span></Radio>
                        </Radio.Group>
            <Form.Item label="How could we improve the way this works for you?">
                <TextArea rows={6} />
            </Form.Item>
            <div className="action-buttons">
          <button
            className="blue"
            onClick={() => setIsConfirmationBoxOpen(false)}
          >
            Submit
          </button>
          <button
            className="cancel-btn"
            onClick={() => setIsConfirmationBoxOpen(false)}
          >
            Cancel
          </button>
        </div>
            </Form>
        </div>
        
        </ConfirmationBox> : null
      }
    </>
  );
}

export default RentalApplicationCustomization;
